import { DATE_FORMATS } from '@constants/general';
import { formatDate } from '@helpers/date';

/**
 * Formats an API date into correct string for frontend display
 */
export const formatFilingDate = (date?: string): string =>
  formatDate(
    date,
    DATE_FORMATS.FILING_TYPES.DATE_FORMAT,
    DATE_FORMATS.FILING_TYPES.DISPLAY_DATE_FORMAT
  );
